import * as React from "react";
import { Box, Layer } from "grommet";
import ScrollContainer from "./ScrollContainer";

const StyledModal = ({ isOpen, setIsOpen, children }: { isOpen: boolean; setIsOpen?: Function; children: any }) => {
    if (isOpen)
        return (
            <Layer full="vertical" position="right" responsive={true} onEsc={() => setIsOpen && setIsOpen(false)} onClickOutside={() => setIsOpen && setIsOpen(false)}>
                <Box width={{ min: "medium" }} pad="medium">
                    <ScrollContainer direction={"-y"}>{children}</ScrollContainer>
                </Box>
            </Layer>
        );

    return <></>;
};

export default StyledModal;
